import React from 'react';
import { debounce } from 'lodash';
import SearchIcon from '@mui/icons-material/Search';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Col, Form, Spinner } from 'react-bootstrap';
import Stack from '@mui/material/Stack';
import { Typography } from '@mui/material';
import { UserpilotHook } from './LabelUserpilotHook';
export interface Option {
  id: number; label: any; value: any; code: string;
}

interface Props {
  hidden?: boolean;
  borderless?: boolean;
  label?: string;
  option: Option[];
  mdCol?: string;
  name: string;
  values?: any;
  onChangeItem?: (e: any) => void;
  isValid?: boolean;
  feedback?: any;
  defautlValues?: any;
  disabled?: boolean;
  placeholder?: string;
  form: any;
  className?: string;
  logo?: string;
  onSearch: (keyword: string) => void;
  iconClass?: string;
  icon?: any;
  inputRef?: any;
  isLoading?: boolean;
  emptyLabel?: any;
  clearOption?: () => void;
  serverFiltered?: boolean;
  /** Stable Userpilot spotlight hook. Do not derive from class names. */
  dataUp?: string;
}

const SelectSearchInput = (props: Props) => {
  let filterByFields = ['label', 'code'];
  const [selected, setSelected] = React.useState([]);

  //  fix filterBy warning
  if (props.option && props.option.length > 0) {
    if (
      props.option.hasOwnProperty('label') &&
      props.option.hasOwnProperty('value') &&
      props.option.hasOwnProperty('code')
    ) {
      filterByFields = ['label', 'value', 'code'];
    }
  }

  return props.hidden ? null : (
    <Form.Group
      className={`py-2 ${props.className ?? ''}`.trim()}
      name={props.name}
      as={Col}
      md={props.mdCol || '6'}
      controlId={`${props.name}_ID`}
      data-up={props.label ? undefined : props.dataUp}
    >
      <Form.Label style={{ fontSize: '1rem', color: '#4E5A6F' }} className={props.logo}>
        {props.label}
        <UserpilotHook dataUp={props.dataUp} />
      </Form.Label>
      <Typeahead
        id={props.name}
        disabled={props.disabled}
        onInputChange={debounce((e) => props.onSearch(e), 500)}
        onChange={(selected: any) => {
          try {
            setSelected(selected);
            props.onChangeItem && props.onChangeItem(selected[0]);

            if (selected[0]?.value) {
              props.form.setFieldValue(props.name, selected[0].value);
            }
          } catch (ex) {
            // skip
          }
        }}
        emptyLabel={
          props.emptyLabel ? (
            props.emptyLabel
          ) : (
            <>
              {props.option?.length === 0 && !!props.values.length && (
                <Stack alignItems={'center'}>
                  {props.option?.length === 0 && !!props.values.length ? (
                    <>
                      <Typography sx={{ color: '#0c2551' }}>Not found</Typography>
                    </>
                  ) : (
                    <>{props.isLoading && <Spinner color="primary" animation="border" />}</>
                  )}
                </Stack>
              )}
            </>
          )
        }
        labelKey="label"
        defaultSelected={props.values ? [props.values] : undefined}
        options={props.option}
        filterBy={props.serverFiltered ? () => true : filterByFields}
        ref={props.inputRef}
        isLoading={props.isLoading}
        onBlur={() => {
          if (!selected.length) {
            props.inputRef?.current?.clear();
            if (props.clearOption) props.clearOption();
          }
        }}
        inputProps={
          !props.label && props.dataUp
            ? ({ 'data-up': props.dataUp } as React.InputHTMLAttributes<HTMLInputElement>)
            : undefined
        }
      />
      <div className={`${props.iconClass ?? 'text-field-light'} icon-search-prefix `}>
        {props.icon ? props.icon : <SearchIcon />}
      </div>
      {props.feedback && (
        <div className="sized70 text-field-light w-100 d-flex justify-content-between mh-1rem">
          {props.feedback}
        </div>
      )}
      <style scoped>{`
        .rbt > div > input {
          padding-left: 32px;
        }
        .rbt-aux {
          position: absolute;
          top:16px;
          left:9px;
        }
      `}</style>
    </Form.Group>
  );
};

export default SelectSearchInput;
